<template>
  <customModal :containerxl="true" @closeModal="closeModal()">
    <template #title>
      {{ popupheadder }}
    </template>
    <template #body>
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm" v-if="highriskitems.length > 0">
          <thead>
            <tr>
              <th v-if="requiredsite">Site Code</th>
              <th>Risk Name</th>
              <th>Risk score</th>
              <th>Risk Level</th>
              <th>Probability</th>
              <th>Impact</th>
              <th>Detectability</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in highriskitems" :key="item.id">
              <td v-if="requiredsite">{{ item.siteCode }}</td>
              <td>{{ item.riskName }}</td>
              <td>
                <div
                  class="inround"
                  :style="{ backgroundColor: item.riskLevelColor, color:testcolorfun(item.riskLevelColor) }"
                >
                  {{ item.score }}
                </div>
              </td>
              <td>{{ item.riskLevelLabel }}</td>
              <td>{{ item.probability }}</td>
              <td>{{ item.impact }}</td>
              <td>{{ item.detectability }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else class="text-center py-3">
          No data found
        </div>
      </div>
    </template>
  </customModal>
</template>
<script>

import customModal from "../customModal/customModal.vue";

export default {
    name: 'AlertStatusPopup',
    components: {
        customModal
    },
    props: {
      popupheadder:{
        type: String,
        default:""
      },
      requiredsite:{
        type: Boolean,
        default: false
      },
        highriskitems: {
      type: Array,
      required: true,
      default: () => [],
    },
    },
    methods: {
  closeModal() {
    this.$emit("closeModal");
  },
 testcolorfun(riskcolor){
  if(riskcolor == "#F22613" || riskcolor == "#E74C3C"){
    return "#ffffff"
  }
  else{
    return "#000000"
  }
 }
}
    }
</script>
<style scoped>
  .inround[data-v-6e2c0f0a] {
    width: 50px;
    border-radius: 10%;
    text-align: center;
}
</style>